import {PersonnelEN} from "./personnel/en";
import {AssetEN} from "./assest/en";
import {WageEN} from "./wage/en";


export const HrmEN = {
    ...PersonnelEN,
    ...AssetEN,
    ...WageEN,
}